import { getCookie } from '@zooplus/commons-lang';

import { MOBILE_APP_COOKIE } from '@utilities/constants';

const isMobileApp = Boolean(getCookie(MOBILE_APP_COOKIE));

export const useMobileApp = () => isMobileApp;
